import AbstractController from '../src/services/ControllersRepository/AbstractController';

export default class OrderStatuses extends AbstractController {
    protected controllerName = 'OrderStatuses';
}
